module.exports = __webpack_public_path__ + "static/img/manhole.a151c05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/objectIcons/manhole.png
// module id = ./src/assets/objectIcons/manhole.png
// module chunks = 1